import { render, staticRenderFns } from "./GenericReviewDetail.vue?vue&type=template&id=1f45eabe&scoped=true"
import script from "./GenericReviewDetail.vue?vue&type=script&lang=js"
export * from "./GenericReviewDetail.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/journal_detail.css?vue&type=style&index=0&id=1f45eabe&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f45eabe",
  null
  
)

export default component.exports